export function MetricCardTooltips(header) {
    switch (header) {
        case "Total Written Premium":
            return "Total amount of premium an insurance policyholder pays for coverage over a specific period of time. This includes New and Renewal Premium, Endorsements and Cancelled policies.";
        case "Earned Premium":
            return "The portion of an insurance premium that an insurance company has earned for a policy.";
        case "Total PIF":
            return "Count of policies that are in effect at a point in time.";
        case "184 Day Retention":
            return "Percentage of policies retained for 184 days after the effective date.";
        case "365 Day Retention":
            return "Percentage of policies retained for 365 days after the effective date.";
        case "Loss Ratio":
            return "Ratio of (Losses Paid + Reserves) to Earned Premium.";
        case "Quotes":
            return "Count of applicants quoted.";
        case "New Business":
            return "Count of new policies written.";
        case "Conversion (Closure)":
            return "Percentage of quotes bound.";
        case "New Business Written Premium":
            return "The amount of premium at the time the policy is written.";
        case "30 Day Attrition":
            return "Percentage of policies attriting within 30 days after the effective date.";
        default:
            return "";
    }
}

export function ReportChartConsts(chart) {
    return {
        wpByLob: {
            title: "Total Written Premium by Line of Business",
            tooltipContent: "Distribution of Annualized Total Written Premium by Line of Business as a percentage of Total Written Premium for the selected Agency/Agent.",
        },
        pifWpRetention: {
            title: "PIF, Total Written Premium, & Retention by Month",
            tooltipContent: "Historical overview of Total Written Premium, Policies In Force and Retention over time for the selected Agency/Agent."
        },
        pifRetention: {
            title: "PIF & Retention by Month",
            tooltipContent: "Historical overview of Policies In Force and Retention over time for the selected Agency/Agent."
        },
        quotesNbusByLob: {
            title: "Quotes & New Business by Line of Business",
            tooltipContent: "Historical overview of Quotes and New Business by Line of Business over time for the selected Agency/Agent. This visualization can be filtered by Agency State and for the selected Agency/Agent."
        },
        monthOverMonth: {
            title: "Current and Prior Trailing 1 Month Period",
            tooltipContent: "Comparison of last 30 days to previous 30 day time period for Quotes, New Business, Closure and New Business Written Premium. This visualization is a static view so the timeframe cannot be adjusted."
        },
        nbwpByMonth: {
            title: "New Business Written Premium by Line of Business",
            tooltipContent: "Historical overview of New Business Written Premium by Line of Business over time. This visualization can be filtered by Date Range, Agency State and for the selected Agency/Agent."
        },
        quotesNbusConversion: {
            title: "Quotes, New Business & Conversion by Month",
            tooltipContent: "Historical overview of Quotes, New Business and Closure over time for the selected Agency State and for the selected Agency/Agent."
        },
        nbusByBrachOrProducer: {
            title: "New Business By Branch or Producer",
            tooltipContent: "Summary of highest New Business count by Branch (or Producer). This visualization can be filtered by Date Range, Agency State and for the selected Agency/Agent."
        },
        ppaNbusBySegment: {
            title: "PPA New Business by Risk Segment",
            tooltipContent: "Distribution of Private Passenger Auto Risk Segmentation. This visualization can be filtered by Date Range, Agency State and for the selected Agency/Agent."
        },
        commercialNbusBySegment: {
            title: "Commercial New Business by Segment",
            tooltipContent: "Distribution of Commercial Business Segmentation. This visualization can be filtered by Date Range, Agency State and for the selected Agency/Agent."
        }
    }[chart]
};